import { render, staticRenderFns } from "./UniDetailFaculty.vue?vue&type=template&id=680e7b4b&scoped=true&"
import script from "./UniDetailFaculty.vue?vue&type=script&lang=js&"
export * from "./UniDetailFaculty.vue?vue&type=script&lang=js&"
import style0 from "./UniDetailFaculty.vue?vue&type=style&index=0&id=680e7b4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680e7b4b",
  null
  
)

export default component.exports